import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import { ShieldCheck, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/request-password-reset", { email });
      setSent(true);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="text-center mb-6">
        <div className="inline-flex w-14 h-14 rounded-md bg-brand items-center justify-center mb-4">
          <ShieldCheck className="w-7 h-7 text-white" strokeWidth={2.4} />
        </div>
        <h1 className="text-3xl font-outfit font-bold text-white">Reset your password</h1>
        <p className="text-white/60 text-sm mt-1 font-manrope">We&apos;ll email you a secure link that expires in 1 hour.</p>
      </div>

      {sent ? (
        <div className="card-flat p-6 text-center space-y-3">
          <div className="inline-flex w-12 h-12 rounded-full bg-gold-50 items-center justify-center">
            <Mail className="w-6 h-6 text-gold-500" />
          </div>
          <div className="font-outfit font-semibold text-white">Check your inbox</div>
          <p className="text-sm text-white/60 font-manrope">If that email is registered, a reset link is on its way.</p>
          <Link to="/login" className="inline-block text-brand font-semibold text-sm font-manrope">Back to login</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="card-flat p-6 space-y-4">
          <div>
            <Label className="font-manrope">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" placeholder="you@example.com" />
          </div>
          {error && <div className="text-sm text-red-600 font-manrope">{error}</div>}
          <Button type="submit" disabled={busy} className="w-full bg-brand hover:bg-brand-hover text-white py-6 font-manrope font-semibold" data-testid="forgot-submit">
            {busy ? "Sending…" : "Send reset link"}
          </Button>
          <div className="text-center text-sm text-white/70 font-manrope">
            Remembered it? <Link to="/login" className="text-brand font-semibold">Back to login</Link>
          </div>
        </form>
      )}
    </div>
  );
}
